import { useCallback, useState } from 'react';
// NOTE if something is changed here. change in context as well
export const useTransactionStepper = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [incrementNumber, setIncrementNumber] = useState(-1);
    const nextStep = useCallback((incr = 1) => {
        setCurrentStep((prev) => prev + incr);
    }, []);
    const prevStep = useCallback((incr = incrementNumber) => {
        setCurrentStep((prev) => prev + incr);
    }, [incrementNumber]);
    const resetStepper = useCallback(() => {
        setCurrentStep(0);
    }, []);
    const adjustCurrentStep = useCallback((step) => {
        setCurrentStep(step);
    }, []);
    return {
        currentStep,
        nextStep,
        prevStep,
        resetStepper,
        adjustCurrentStep,
        setIncrementNumber,
        incrementNumber,
    };
};
//# sourceMappingURL=useTransactionStepper.js.map